export const FETCH_RUNNER_SUBSRIPTION_INIT_ACTION =
  "FETCH_RUNNER_SUBSRIPTION_INIT_ACTION";
export const FETCH_RUNNER_SUBSRIPTION_SUCCESS_ACTION =
  FETCH_RUNNER_SUBSRIPTION_INIT_ACTION + "_SUCCESS";
export const FETCH_RUNNER_SUBSRIPTION_FAIL_ACTION =
  FETCH_RUNNER_SUBSRIPTION_INIT_ACTION + "_ERROR";

export const CREATE_REQUESTSUBSCRPTN_INIT_ACTION =
  "CREATE_REQUESTSUBSCRPTN_INIT_ACTION";
export const CREATE_REQUESTSUBSCRPTN_SUCCESS_ACTION =
  CREATE_REQUESTSUBSCRPTN_INIT_ACTION + "_SUCCESS";
export const CREATE_REQUESTSUBSCRPTN_FAIL_ACTION =
  CREATE_REQUESTSUBSCRPTN_INIT_ACTION + "_ERROR";

export const CREATE_INVOICE_ACTION = "CREATE_INVOICE_ACTION";
export const CREATE_INVOICE_FAIL_ACTION = CREATE_INVOICE_ACTION + "_ERROR";
export const CREATE_INVOICE_SUCCESS_ACTION = CREATE_INVOICE_ACTION + "_SUCCESS";

export const CREATE_PAYMENT_ACTION = "CREATE_PAYMENT_ACTION";
export const CREATE_PAYMENT_FAIL_ACTION = CREATE_PAYMENT_ACTION + "_ERROR";
export const CREATE_PAYMENT_SUCCESS_ACTION = CREATE_PAYMENT_ACTION + "_SUCCESS";

export const FETCH_CARGOSIZE_LIST_INIT_ACTION =
  "FETCH_CARGOSIZE_LIST_INIT_ACTION";
export const FETCH_CARGOSIZE_LIST_SUCCESS_ACTION =
  FETCH_CARGOSIZE_LIST_INIT_ACTION + "_SUCCESS";
export const FETCH_CARGOSIZE_LIST_FAIL_ACTION =
  FETCH_CARGOSIZE_LIST_INIT_ACTION + "_ERROR";

export const CREATE_CANCELREQUEST_INIT_ACTION =
  "CREATE_CANCELREQUEST_INIT_ACTION";
export const CREATE_CANCELREQUEST_SUCCESS_ACTION =
  CREATE_CANCELREQUEST_INIT_ACTION + "_SUCCESS";
export const CREATE_CANCELREQUEST_FAIL_ACTION =
  CREATE_CANCELREQUEST_INIT_ACTION + "_ERROR";

export const FETCH_HISTORYRUNNER_SUBSRIPTION_INIT_ACTION =
  "FETCH_HISTORYRUNNER_SUBSRIPTION_INIT_ACTION";
export const FETCH_HISTORYRUNNER_SUBSRIPTION_SUCCESS_ACTION =
  FETCH_HISTORYRUNNER_SUBSRIPTION_INIT_ACTION + "_SUCCESS";
export const FETCH_HISTORYRUNNER_SUBSRIPTION_FAIL_ACTION =
  FETCH_HISTORYRUNNER_SUBSRIPTION_INIT_ACTION + "_ERROR";

export const FETCH_RUNNERSUBSCRIPTION_LOG_ACTION =
  "FETCH_RUNNERSUBSCRIPTION_LOG_ACTION";
export const FETCH_RUNNERSUBSCRIPTION_LOG_FAIL_ACTION =
  FETCH_RUNNERSUBSCRIPTION_LOG_ACTION + "_ERROR";
export const FETCH_RUNNERSUBSCRIPTION_LOG_SUCCESS_ACTION =
  FETCH_RUNNERSUBSCRIPTION_LOG_ACTION + "_SUCCESS";

  export const CLEAR_RUNNERSUBSCRIPTIONLOG_ACTION = "CLEAR_RUNNERSUBSCRIPTIONLOG_ACTION";
